// extracted by mini-css-extract-plugin
export default {"root":"style_root__ACYbU","label":"style_label__UWw-c"};